import _get from 'lodash/get';
import config from '@bedrock-rdk/config';
// eslint-disable-next-line import/no-unresolved
import engine from '@bedrock/fido-sdk/es/services/thirdParty/engines/ssaTealiumHttp.engine';

export const engineName = 'ssaTealiumHttp';

function getBrowserLayer(getUserAgent = false) {
  const url = new URL(window.location.href || '');
  // On Magenta we may have a device-ingested SSO token which contains auth info
  url.searchParams.delete('token');
  const sanitizedUrl = url.toString();
  const sanitizedParams = url.searchParams.toString();

  return {
    'dom.url': sanitizedUrl,
    page_url: sanitizedUrl,
    page_path: window.location.hash,
    page_title: document.title,
    page_query_params: sanitizedParams,
    referrer: document.referrer,
    device_resolution: `${window.screen.width}x${window.screen.height}`,
    viewport_size: `${window.innerWidth}x${window.innerHeight}`,
    pixel_depth: window.screen.pixelDepth,
    device_language: navigator.language,
    ...(getUserAgent && { user_agent: navigator.userAgent }),
  };
}

engine.getBrowserLayer = getBrowserLayer.bind(engine);

export const getEngine = () => {
  const { analytics } = config;
  const { initParams, trackers, taggingPlans, attributesKeysMapping } = analytics;

  return {
    thirdPartyServiceConfig: {
      key: engineName,
      name: engineName,
      bootMethod: () => {},
      engine: () => engine,
      taggingPlan: _get(taggingPlans, engineName, {}),
      initParams: {
        attributesKeysMapping: _get(attributesKeysMapping, engineName, {}),
        events: _get(taggingPlans, engineName, {}),
        trackers: _get(trackers, engineName, {}),
        isSnowplowEnabled: (analytics.engines || []).includes('snowplow'),
        ..._get(initParams, engineName, {}),
      },
    },
    cleanup: () => {},
  };
};
